export const TITLE_HOME_PAGE = 'React Boilerplate';
export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const APP_CONTEXT = 'APP_CONTEXT';
export const RESISTANCE_CONTEXT = false;
